import { Card, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import FormSignUp from './FormSignUp';
import './SignUp.scss'
import LoginPage from 'pages/Login';
import { useState, useEffect } from 'react';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function SignUp() {
	const [activeIndex, setActiveIndex] = useState(0)
	const [regisSuccess, setRegisSuccess] = useState<number>(0)
	const navigate = useNavigate();
	
	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		if (params.get('referral_code')) {
			setActiveIndex(1);
		}
	}, []);
	return (
		<div className="sign-up-page relative min-h-screen overflow-hidden flex items-center justify-center px-4 py-8">
			{activeIndex === 1 &&
				<div>

				</div>}
			<div className="fixed inset-0 w-full h-full -z-20">
				<video
					autoPlay
					loop
					muted
					playsInline
					className="w-full h-full object-cover"
				>
					<source src="/video/new-bg-video.mp4" type="video/mp4" />
					{/* <source src="/video/bg-video.webm" type="video/webm" /> */}
					Your browser does not support the video tag.
				</video>
			</div>
			{/* Video Overlay */}
			<div className="fixed inset-0 bg-white/10 -z-10"></div>

			<div className='absolute top-4 left-4 cursor-pointer w-38 h-12 md:w-48 md:h-22' onClick={() => navigate('/')}>
				<img className='' src='./images/logo2.png' alt='logo'/>
			</div>
			<div className='signUp-container z-10 w-full max-w-lg mx-auto flex justify-center items-center'>
				{activeIndex === 0 ? (
					<Card className="card-custom !p-4 !bg-transparent !bg-white/5 !backdrop-blur-lg !border !border-white/30 !shadow-2xl w-full max-w-md">
						<Typography.Title level={2} className="text-center !text-3xl text-white !mb-8">
							Login
						</Typography.Title>

						<div className='form w-full'>
							<LoginPage />
						</div>

						<div className='flex gap-2 items-center justify-center text-white/90 mt-6'>
							<p>Don't have an account?</p>
							<p className='text-white font-bold cursor-pointer hover:text-white/80 transition-colors duration-200' onClick={() => setActiveIndex(1)}>Register</p>
						</div>

					</Card>
				) : (
					<div className="flex justify-between lg:max-w-4xl mx-auto">
						<FormSignUp setActiveIndex={setActiveIndex} setRegisSuccess={setRegisSuccess} regisSuccess={regisSuccess} />
					</div>
				)
				}
				<ToastContainer />
			</div>

		</div>
	);
}

export default SignUp;